<form [formGroup]="applicationTypeForm">
  <cpds-radio-card-group
    [theme]="'mm-light'"
    [options]="options"
    [allDisabled]="false"
    [allErrors]="false"
    groupName="applicationType"
    [vertical]="false"
    [displayName]="'Application Type'"
    formControlName="isAgentSubmittedApp"
  ></cpds-radio-card-group>
  <div *ngIf="applicationTypeForm.get('isAgentSubmittedApp').value === 'true'" class="application_alert">
    <br />
    <cpds-alert intent="warning">
      If you use the advisor-submitted process, the insured won’t be eligible for Temporary Life Insurance Coverage
      (TLIC).
      <cp-popover class="application-type-learn-more">
        <a label cp-link>
          <span>Learn more</span>
        </a>
        <div content>
          <p>
            The advisor-submitted application process doesn’t yet include a way to offer Temporary Life Insurance
            Coverage (TLIC).
          </p>
          <br />
          <p>
            We created this process so that clients wouldn’t need to create a Coverpath account before submitting their
            application, but without an account, they wouldn’t have a way to accept a TLIC offer.
          </p>
        </div>
      </cp-popover>
    </cpds-alert>
  </div>
</form>
